import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import ExclusionFilter from '../ExclusionFilter';

const { FiSearch, FiBell, FiTrash2, FiHelpCircle } = FiIcons;

const Navbar = ({ clearData }) => {
  return (
    <header className="h-16 bg-white border-b border-slate-200 sticky top-0 z-30 px-8 flex items-center justify-between">
      <div className="flex items-center gap-4 flex-1">
        <div className="relative w-full max-w-sm">
          <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm" />
          <input 
            type="text" 
            placeholder="Search identities or events..." 
            className="w-full pl-10 pr-4 py-1.5 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
          />
        </div>
      </div>

      <div className="flex items-center gap-2">
        <ExclusionFilter />
        <div className="w-px h-6 bg-slate-200 mx-2"></div>
        
        <button className="p-2 text-slate-500 hover:bg-slate-50 rounded-lg transition-colors">
          <SafeIcon icon={FiHelpCircle} />
        </button>
        
        <button className="p-2 text-slate-500 hover:bg-slate-50 rounded-lg transition-colors relative">
          <SafeIcon icon={FiBell} />
          <span className="absolute top-2 right-2 w-2 h-2 bg-rose-500 rounded-full border-2 border-white"></span>
        </button>

        <button 
          onClick={() => window.confirm('Purge all data?') && clearData()}
          className="p-2 text-slate-500 hover:text-rose-600 hover:bg-rose-50 rounded-lg transition-colors"
          title="Clear Telemetry"
        >
          <SafeIcon icon={FiTrash2} />
        </button>

        <div className="ml-2 flex items-center gap-3 pl-4 border-l border-slate-100">
          <div className="text-right hidden sm:block">
            <p className="text-xs font-bold text-slate-900">Admin User</p>
            <p className="text-[10px] text-slate-500">System Architect</p>
          </div>
          <div className="w-8 h-8 bg-slate-900 rounded-full flex items-center justify-center text-white text-xs font-bold">
            AD
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;